module.exports = __webpack_public_path__ + "static/preview-summer-catchers@2x-ab54e69e20f065b847d480f363e46d7f.png";